<template>
  <div class="customizer-header">
    <i class="icofont-close icon-close" @click="closecustomizer()"></i>
    <h5 class="m-b-0">{{customizerTitle}}</h5>

  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'CustomizerConfiguration',
    data() {
      return {
        styleObject: {
          position: 'fixed',
          left: '0',
          top: '0',
          opacity: '0',
        },
      };
    },
    computed: {
      ...mapState({
        customizer: (state) => state.menu.customizer,
        customizerTitle: (state) => state.menu.customizerTitle,
        data: (state) => JSON.stringify(state.layout.layout),
        layout: (state) => state.layout.layout,
      }),
    },
    methods: {
      closecustomizer() {
        this.$store.state.menu.customizer = '';
        this.$store.state.menu.customizerTitle = '';
      },
    },
  };
</script>
